(function ($) {
	var halo = {
	    initSlidableSpotlight: function () {
            var slidableSpotlights = $('[data-slidable-spotlight]');

            if (slidableSpotlights.length) {
                slidableSpotlights.each(function () {
                    var self = $(this);
                    
                    if (!self.hasClass('slick-initialized')) {
                      setTimeout(() => {
                        self.slick({
                          infinite: true,
                          dots: false,
                          slidesToShow: 5,
                          slidesToScroll: 1,
                          rows:1,
                          verticalSwiping: false,
                          fade: false,
                          cssEase: "ease",
                          adaptiveHeight: false,
                          autoplay: false,
                          autoplaySpeed: 3000,
                          arrows: true,
                          nextArrow: window.arrows.icon_next,
                          prevArrow: window.arrows.icon_prev,
                          rtl: window.rtl_slick,
                          touchThreshold: 200,
                          speed: 500,
                          swipeToSlide: true,
                          responsive: [
                            {
                              breakpoint: 1366,
                              settings: {
                                slidesToShow: 4,
                                slidesToScroll: 1,
                              },
                            },
                            {
                              breakpoint: 768,
                              settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                              },
                            },
                            {
                              breakpoint: 555,
                              settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                              },
                            },
                          ],
                        });
                      }, 300);
                    }
                });
            }
        }
	}
	halo.initSlidableSpotlight();
    if ($('body').hasClass('cursor-fixed__show')){
        window.sharedFunctionsAnimation.onEnterButton();
        window.sharedFunctionsAnimation.onLeaveButton();
    }
})(jQuery);